// src/components/Center Admin/forms/sentToLab.tsx
import React, { useState, useMemo } from "react";
import "../../../center admin css/BUSampleForm.css"; // 🔥 USE SAME CSS
import "../../../center admin css/centerAdmin.css";
import api from "../../../api/axiosConfig";

interface BnuSampleFormProps {
  emrId?: string;
  emrIds?: string[];
  sessionId?: string;
  onSuccess?: () => void;
}

const BnuSampleForm: React.FC<BnuSampleFormProps> = ({
  emrId,
  emrIds,
  sessionId,
  onSuccess,
}) => {
  const [selectedChoice, setSelectedChoice] = useState<"True" | "False" | "">(
    "",
  );
  const [loading, setLoading] = useState(false);
  // const sessionId =
  //   sessionStorage.getItem("workflowSessionId") ||
  //   sessionStorage.getItem("sessionId") ||
  //   "";

  const allEmrIds = useMemo(() => {
    if (emrIds && emrIds.length) return emrIds;
    if (emrId) return [emrId];
    return [];
  }, [emrId, emrIds]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!selectedChoice) {
      alert("Please select True or False before submitting.");
      return;
    }

    if (!allEmrIds.length) {
      alert("No EMR ID(s) available to submit.");
      return;
    }

    try {
      setLoading(true);

      for (const id of allEmrIds) {
        const payloadToServer = {
          emrId: id,
          "Blood Sample Sent to Lab?": selectedChoice === "True",
        };

        // send payload as request body using axios; axios returns data on res.data
        const res = await api.dataCollectionApi.post(
          "/api/forms/sent-to-lab",
          payloadToServer,
        );

        const body = res.data;

        if (!body?.success) {
          throw new Error(body?.message || "Submission failed");
        }
        if (sessionId) {
          await api.centerworkflowApi.post(
            `/sessions/${encodeURIComponent(
              sessionId,
            )}/center-admin/forms/LAB_SAMPLE_PICKUP/submit`,
            {
              pickedUp: selectedChoice === "True" ? "yes" : "no",
              remarks: "Sample picked up",
            },
          );
        }
      }

      alert("Blood Sample Sent to Lab submitted successfully!");

      // reset form
      setSelectedChoice("");

      // ✅ CLEAR SELECTED PATIENTS FROM UI
      onSuccess?.();
    } catch (err: any) {
      console.error("Error:", err);
      alert(`Error submitting form: ${err?.message || "Unknown error"}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="bu-form-container" onSubmit={handleSubmit}>
      <div className="vs-section-bar">Blood Sample</div>
      {/* 🔥 TEAL CARD WRAPPER */}
      <div className="bu-section-card">
        {/* 🔥 HEADER (matches BUSampleForm + AD Minor) */}
        <div className="bu-section-header">
          <h4>Blood Sample Sent to Lab?</h4>
        </div>

        {/* 🔥 BODY */}
        <div className="bu-section-body">
          <div className="bu-radio-row">
            <label className="ack-radio">
              <input
                type="radio"
                name="lp-sent"
                value="True"
                checked={selectedChoice === "True"}
                onChange={() => setSelectedChoice("True")}
                disabled={loading}
              />
              <span className="radio-custom"></span>
              <span className="radio-label">True</span>
            </label>

            <label className="ack-radio">
              <input
                type="radio"
                name="lp-sent"
                value="False"
                checked={selectedChoice === "False"}
                onChange={() => setSelectedChoice("False")}
                disabled={loading}
              />
              <span className="radio-custom"></span>
              <span className="radio-label">False</span>
            </label>
          </div>
        </div>
      </div>

      {/* 🔥 ACTION BUTTONS (VisionScreening style) */}
      <div className="audio-actions">
        <button type="button" className="audio-btn audio-btn-secondary">
          Close
        </button>
        <button
          type="submit"
          className="audio-btn audio-btn-primary"
          disabled={loading}
        >
          {loading ? "Submitting..." : "Submit Assessment"}
        </button>
      </div>
    </form>
  );
};

export default BnuSampleForm;
